import React from "react";
import { Line } from "react-chartjs-2";
import { useProfile } from "../contexts/ProfileContext"; // Import the useProfile hook
import { useEffect, useState } from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend, Filler
} from "chart.js";
// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const LineChart = ({ followers, growthRate, days }) => {
  days = days || 30;

  // Generate labels for 30 days
  const labels = Array.from({ length: days + 1 }, (_, i) => {
    const date = new Date();
    date.setDate(date.getDate() + i);
    return date.toLocaleDateString("en-US", {
      month: "short", 
      day: "numeric",
    });
  });

  // Create deterministic volatility based on follower count
  const getVolatility = (day, baseFollowers) => {
    const seed = (baseFollowers % 100) + day;
    const amplitude = parseInt(growthRate) * 0.9; // 30% volatility
    return Math.sin(seed * 0.5) * amplitude;
  };

  // Generate follower data points
  const followerData = [];
  const dailyGrowth = parseInt(growthRate);
  let currentFollowers = followers;

  // Calculate step size to show 11 points
  const step = Math.max(1, Math.floor(days / 10));

  // Add data point for each day
  for (let i = 0; i <= days; i++) {
    // Add volatility to daily growth
    const volatility = getVolatility(i, followers);
    
    // Only add growth after first day
    if (i > 0) {
      if (i === days) {
        currentFollowers = followers + (dailyGrowth * days); // Exact target for last day
      } else {
        currentFollowers = Math.round(currentFollowers + dailyGrowth + volatility);
      }
    }
    
    // Include points at regular intervals to show 11 total points
    if (i % step === 0 || i === days) {
      followerData.push(currentFollowers);
    }
  }

  // Filter labels to match data points
  const filteredLabels = labels.filter((_, index) => index % step === 0 || index === days);

  const data = {
    labels: filteredLabels,
    datasets: [
      {
        label: "Followers",
        data: followerData,
        borderColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) return null;

          // Create gradient for the line
          const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
          gradient.addColorStop(1, "#089fe9"); // Light blue
          gradient.addColorStop(0.8, "#5c74ed"); // Blue
          gradient.addColorStop(0.55, "#d345c6"); // Pink
          gradient.addColorStop(0.4, "#fa4a58"); // Red
          gradient.addColorStop(0.3, "#ff832a"); // Orange
		  gradient.addColorStop(0.10, "#fed106"); // Yellow
          gradient.addColorStop(0, "#fed106"); // Yellow
          return gradient;
        },
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea, scales } = chart;

          if (!chartArea) return null;

          // Create a horizontal gradient aligned with the x-axis sections
          const gradient = ctx.createLinearGradient(chartArea.left, 0, chartArea.right, 0);

          // Define color stops for each section
          /*var colors = [
            "rgba(254, 209, 6, 0.2)",   // #fed106 Yellow
            "rgba(255, 131, 42, 0.2)",   // #ff832a Orange
            "rgba(255, 131, 42, 0.2)",   // #ff832a Orange
            "rgba(250, 74, 88, 0.2)",   // #fa4a58 Red
            "rgba(250, 74, 88, 0.2)",   // #fa4a58 Red
            "rgba(250, 74, 88, 0.2)",   // #fa4a58 Red
            "rgba(152, 84, 255, 0.2)",  // #9854ff Purple
            "rgba(152, 84, 255, 0.2)",  // #9854ff Purple
            "rgba(92, 116, 237, 0.2)",  // #5c74ed Blue
            "rgba(92, 116, 237, 0.2)",  // #5c74ed Blue
            "rgba(8, 159, 233, 0.2)"   // #089fe9 Light blue
          ];*/

		  var colors = []
		  var colorSegments = Math.floor(step / step);

		 
			// Add first color segment
			for (let i = 0; i < colorSegments; i++) {
				colors.push("rgba(254, 209, 6, 0.2)");
			}
			// Add second color segment  
			for (let i = 0; i < colorSegments; i++) {
				colors.push("rgba(255, 131, 42, 0.2)");
				colors.push("rgba(255, 131, 42, 0.2)");
			}
			// Add third color segment
			for (let i = 0; i < colorSegments; i++) {
				colors.push("rgba(250, 74, 88, 0.2)");
				colors.push("rgba(250, 74, 88, 0.2)");
				colors.push("rgba(250, 74, 88, 0.2)");
			}
			// Add fourth color segment
			for (let i = 0; i < colorSegments; i++) {
				colors.push("rgba(152, 84, 255, 0.2)");
				colors.push("rgba(152, 84, 255, 0.2)");
			}
			// Add fifth color segment
			for (let i = 0; i < colorSegments; i++) {
				colors.push("rgba(92, 116, 237, 0.2)");
				colors.push("rgba(92, 116, 237, 0.2)");
			}
			// Add sixth color segment
			for (let i = 0; i < colorSegments; i++) {
				colors.push("rgba(8, 159, 233, 0.2)");
			}
		  
		  

          const numLabels = filteredLabels.length;
          for (let i = 0; i < numLabels; i++) {
            const position = i / (numLabels - 1); // Divide evenly based on label positions
            gradient.addColorStop(position, colors[i % colors.length]);
          }

          return gradient;
        },
        borderWidth: 3,
        tension: 0.4, // Smooth curve
        fill: true, // Enable gradient fill
        pointRadius: (context) => {
          // Make the last point larger since it will be a star
          return context.dataIndex === context.dataset.data.length - 1 ? 8 : 5;
        },
        pointHoverRadius: 8, // Size on hover
        pointBackgroundColor: "#ffffff", // Background color of points
        pointStyle: (context) => {
          // Make the last point a star
          return context.dataIndex === context.dataset.data.length - 1 ? 'star' : 'circle';
        },
        pointBorderColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) return null;

          // Same gradient for the point border
          const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
          gradient.addColorStop(0, "#fed106");    // Yellow
          gradient.addColorStop(0.22, "#ff832a"); // Orange
          gradient.addColorStop(0.44, "#fa4a58"); // Red
          gradient.addColorStop(0.58, "#d345c6"); // Pink
          gradient.addColorStop(0.72, "#9854ff"); // Purple
          gradient.addColorStop(0.86, "#5c74ed"); // Blue
          gradient.addColorStop(1, "#089fe9");    // Light blue
          return gradient;
        },
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
      title: {
        display: true,
        text: ``,
      },
      tooltip: {
        backgroundColor: 'white',
        titleColor: 'black',
        bodyColor: 'black',
        borderColor: '#ddd',
        borderWidth: 1,
        padding: 15,
        titleSpacing: 8, // Add spacing between title and body
        bodySpacing: 8, // Add spacing between body items
        displayColors: false // Hide color boxes to give more spacing
      }
    },
    scales: {
      x: {
        grid: {
          display: false, // Hide vertical grid lines
        },
      },
      y: {
        grid: {
          color: "rgba(200, 200, 200, 0.2)", // Dashed grid lines
          borderDash: [5, 5],
		  display: false
        },
        beginAtZero: false,
        ticks: {
          stepSize: 50, // Adjust based on your data range
        },
      },
    },
  };

  return <div style={{ maxWidth: "500px", margin: "0 auto" }}><Line data={data} options={options} /></div>;
};

export default LineChart;
